import React from 'react';
import { Button } from '@/components/ui/button';
import { Eye } from 'lucide-react';

const GuestModeBanner = () => {
  const handleSignIn = () => {
    // Clear any existing auth state to prevent "invalid_state_parameter" errors
    document.cookie = 'session_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    localStorage.removeItem('token');
    
    const redirectUrl = `${window.location.origin}/dashboard`;
    const authUrl = process.env.REACT_APP_AUTH_URL || 'https://auth.emergentagent.com';
    const nonce = Date.now(); // Prevent browser caching
    window.location.href = `${authUrl}/?redirect=${encodeURIComponent(redirectUrl)}&_t=${nonce}`;
  };

  return (
    <div className="bg-gradient-to-r from-amber-100 to-orange-100 border-b-2 border-amber-300 px-6 py-3 flex items-center justify-between gap-4 flex-wrap">
      <div className="flex items-center gap-3">
        <Eye className="w-5 h-5 text-amber-700" />
        <p className="text-sm md:text-base font-medium text-amber-900">
          <span className="font-bold">Guest Mode</span> - Sign in with Google and subscribe to create your own stories
        </p>
      </div>
      <Button
        onClick={handleSignIn}
        className="bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white font-semibold px-6"
      >
        Sign In
      </Button>
    </div>
  );
};

export default GuestModeBanner;
